import { getFromMemory, setInMemory, clearMemory, clearAllMemory } from './memoryCache';
import { getFromDB, setInDB, removeFromDB, clearAllFromDB } from './indexedDBCache';

export function readCache(key: string): any[] | null {
  const memEntry = getFromMemory(key);
  if (memEntry) return memEntry.data;
  return null;
}

export async function readCacheAsync(key: string): Promise<any[] | null> {
  const memEntry = getFromMemory(key);
  if (memEntry) return memEntry.data;

  const dbEntry = await getFromDB(key);
  if (dbEntry) {
    setInMemory(key, dbEntry.data);
    return dbEntry.data;
  }

  return null;
}

export function writeCache(key: string, data: any[]): void {
  setInMemory(key, data);
  setInDB(key, data).catch(() => {});
}

export function clearCache(key: string): void {
  clearMemory(key);
  removeFromDB(key).catch(() => {});
}

export function clearAllCampaignCaches(): void {
  clearAllMemory();
  clearAllFromDB().catch(() => {});

  const legacyKeys = [
    'call_campaign_leads_cache',
    'call_campaign_leads_cache_timestamp',
    'whatsapp_campaign_leads_cache',
    'whatsapp_campaign_leads_cache_timestamp',
    'email_campaign_leads_cache',
    'email_campaign_leads_cache_timestamp',
    'linkedin_campaign_leads_cache',
    'linkedin_campaign_leads_cache_timestamp',
    'omni_campaign_leads_cache',
    'omni_campaign_leads_cache_timestamp',
    'inbound_campaign_leads_cache',
    'inbound_campaign_leads_cache_timestamp',
    'inbound_source_leads_cache',
    'inbound_source_leads_cache_timestamp',
    'meetings_booked_cache',
    'meetings_booked_cache_timestamp',
    'campaign_stats_v1',
  ];

  const allKeys = Object.keys(localStorage);
  const supabaseCacheKeys = allKeys.filter(key => key.startsWith('supabase_table_'));
  [...legacyKeys, ...supabaseCacheKeys].forEach(k => {
    try { localStorage.removeItem(k); } catch {}
  });
}

export async function hydrateMemoryFromDB(keys: string[]): Promise<void> {
  await Promise.all(
    keys.map(async (key) => {
      if (getFromMemory(key)) return;
      const dbEntry = await getFromDB(key);
      if (dbEntry) {
        setInMemory(key, dbEntry.data);
      }
    })
  );
}

export function migrateLegacyLocalStorage(keyMappings: Array<{ localStorage: string; cacheKey: string }>): void {
  for (const { localStorage: lsKey, cacheKey } of keyMappings) {
    try {
      const raw = localStorage.getItem(lsKey);
      if (!raw) continue;
      const data = JSON.parse(raw);
      if (Array.isArray(data) && data.length > 0) {
        setInMemory(cacheKey, data);
        setInDB(cacheKey, data).catch(() => {});
      }
      localStorage.removeItem(lsKey);
      localStorage.removeItem(`${lsKey}_timestamp`);
    } catch {
      localStorage.removeItem(lsKey);
      localStorage.removeItem(`${lsKey}_timestamp`);
    }
  }
}
